export default __webpack_public_path__ + "static/media/edital10.a18d966a.pdf";